"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolsSidebar = exports.ToolsSidebarWrap = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var __1 = require("..");
var ToolsSidebarWrap = /** @class */ (function (_super) {
    __extends(ToolsSidebarWrap, _super);
    function ToolsSidebarWrap(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: window.innerWidth > 960
        };
        _this.open = _this.open.bind(_this);
        _this.close = _this.close.bind(_this);
        _this.toggle = _this.toggle.bind(_this);
        return _this;
    }
    ToolsSidebarWrap.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.isOpen !== this.props.isOpen) {
            this.setState({ isOpen: nextProps.isOpen });
        }
    };
    ToolsSidebarWrap.prototype.open = function () {
        this.setState({ isOpen: true });
        if (this.props.onOpen)
            this.props.onOpen();
        if (this.props.onUpdate)
            this.props.onUpdate(true);
    };
    ToolsSidebarWrap.prototype.close = function () {
        this.setState({ isOpen: false });
        if (this.props.onClose)
            this.props.onClose();
        if (this.props.onUpdate)
            this.props.onUpdate(false);
    };
    ToolsSidebarWrap.prototype.toggle = function () {
        if (this.state.isOpen) {
            this.close();
        }
        else {
            this.open();
        }
    };
    ToolsSidebarWrap.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, onUpdate = _a.onUpdate, isOpen = _a.isOpen, onOpen = _a.onOpen, onClose = _a.onClose, rest = __rest(_a, ["children", "className", "onUpdate", "isOpen", "onOpen", "onClose"]);
        return (React.createElement("div", __assign({ className: classNames('sok-tools-sidebar-wrap', className, {
                open: this.state.isOpen
            }) }, rest),
            React.createElement("div", { className: "sok-tools-sidebar-container" }, children),
            React.createElement("button", { className: "sok-tools-sidebar-toggle-button", onClick: this.toggle },
                React.createElement(__1.Icon, { className: this.state.isOpen ? 'fa-chevron-right' : 'fa-chevron-left' }))));
    };
    return ToolsSidebarWrap;
}(React.Component));
exports.ToolsSidebarWrap = ToolsSidebarWrap;
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('ToolsSidebar'), (0, recompose_1.defaultProps)({
    headerText: 'Tools',
    headerIcon: React.createElement(__1.Icon, { className: "fa-wrench" })
}));
/**
 * Sidebar with header.
 */
exports.ToolsSidebar = enhance(function (_a) {
    var className = _a.className, style = _a.style, children = _a.children, headerText = _a.headerText, headerIcon = _a.headerIcon;
    return (React.createElement("div", { className: classNames('sok-tools-sidebar', className), style: style },
        React.createElement("header", { className: 'sok-tools-sidebar-header' },
            React.createElement("span", { className: "sok-tools-sidebar-header-icon" }, headerIcon),
            React.createElement("span", { className: "sok-tools-sidebar-header-text" }, headerText)),
        React.createElement("div", { className: 'sok-tools-sidebar-content' }, children)));
});
//# sourceMappingURL=index.js.map